<template>
  <v-card>
    <v-card-title primary-title class="warning lighten-2">
      {{ label }}
    </v-card-title>
    <v-card-text class="pt-2">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center">ชื่อ - ชื่อสกุล Name & Surname</th>
              <th class="text-center">อายุ Age</th>
              <th class="text-center">อาชีพ/ตำแหน่ง Occupation/Position</th>
              <th class="text-center">ที่อยู่/ที่ทำงาน Address/Office</th>
              <th class="text-center">โทรศัพท์ Telephone</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in 3" :key="index">
              <td>
                <v-text-field
                  v-model="$store.state.dataFrm.list_Ref.tea_ref_name[index]"
                  :label="'ชื่อคนที่ ' + (index + 1)"
                ></v-text-field>
              </td>
              <td class="text-center">
                <v-text-field
                  v-model="$store.state.dataFrm.list_Ref.tea_ref_age[index]"
                  :label="'อายุ คนที่ ' + (index + 1)"
                  type="number"
                ></v-text-field>
              </td>
              <td class="text-center">
                <v-select
                  v-model="$store.state.dataFrm.list_Ref.tea_ref_job[index]"
                  :items="$store.getters.get_Occupation"
                  item-text="occ_description"
                  item-value="occ_id"
                  :label="'อาชีพ คนที่ ' + (index + 1)"
                ></v-select>
              </td>
              <td class="text-center">
                <v-text-field
                  v-model="$store.state.dataFrm.list_Ref.tea_ref_address[index]"
                  :label="'ที่อยู่ คนที่ ' + (index + 1)"
                ></v-text-field>
              </td>
              <td class="text-center">
                <v-text-field
                  v-model="$store.state.dataFrm.list_Ref.tea_ref_phone[index]"
                  :label="'เบอร์โทรศัพท์ คนที่ ' + (index + 1)"
                ></v-text-field>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <!-- {{ $store.state.dataFrm.list_Ref }} -->
    </v-card-text>
  </v-card>
</template>
<script>
// import datetimepicker_TH from "./datetimepickerTH";
export default {
  data() {
    return {};
  },
  components: {
    // datetimepicker_TH,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
  },
  computed: {},
};
</script>
<style scoped>
.flex-center {
  display: flex;
  justify-content: center;
}
</style>
